import { FC } from 'react';
import Head from 'next/head';
import { SimpleQuestion } from 'src/common/types/common/SimpleQuestion';

type FAQSchemaProps = {
  faqs: SimpleQuestion[];
};

type FAQSchemaType = {
  '@type': 'Question';
  name: string;
  acceptedAnswer: {
    '@type': 'Answer';
    text: string;
  };
};

const createSchema = (faqs: SimpleQuestion[]): FAQSchemaType[] => faqs
  .map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  }));

const FAQSchema: FC<FAQSchemaProps> = ({
  faqs,
}) => (
  faqs.length > 0 ? (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: createSchema(faqs),
          }),
        }}
      />
    </Head>
  ) : null);

export default FAQSchema;
